import type { Tenant } from '@/common/overmind/namespaces/tenants';
import { useAppState } from '@/overmind';

type SelectTenant = Record<string, Tenant[]>;

export function useSelectableTenants() {
  const availableTenantsState = useAppState().tenants.availableTenants;
  const availableTenants =
    availableTenantsState.type === 'AVAILABLE'
      ? availableTenantsState.context.tenants
      : [];

  const selectableTenants = Object.entries(
    availableTenants.reduce<SelectTenant>((organizations, tenant) => {
      if (!organizations[tenant.organizationName]) {
        organizations[tenant.organizationName] = [];
      }
      organizations[tenant.organizationName].push(tenant);
      return organizations;
    }, {})
  );

  return selectableTenants;
}
